import script from "./CollectionPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollectionPanel.vue?vue&type=script&lang=ts&setup=true"

import "./CollectionPanel.vue?vue&type=style&index=0&id=d665626e&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d665626e"]])

export default __exports__